module.exports = __webpack_public_path__ + "img/微信图片_20241212192556.a0c96c15.png";